var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "p-4 bg-white rounded-lg shadow-md" }, [
        _c("h2", { staticClass: "text-lg font-semibold mb-4" }, [
          _vm._v("Privacy Policy")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            ' This Privacy Policy ("Policy") explains how Carthike ("we", "us", or "our") collects, uses, and discloses your personal information when you use our Shopify application ("App"). '
          )
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v("Information We Collect")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " When you use our App, we may collect the following types of personal information: "
          )
        ]),
        _c("ul", { staticClass: "list-disc pl-4 mb-4" }, [
          _c("li", [
            _vm._v(
              " Information you provide: When you install our App, we may collect personal information such as your name, email address, and billing information. "
            )
          ]),
          _c("li", [
            _vm._v(
              " Information we collect automatically: When you use our App, we may automatically collect certain information about your device and usage of the App. This information may include your device's IP address, browser type, device type, and the pages or features of the App that you access. "
            )
          ]),
          _c("li", [
            _vm._v(
              " Information from third parties: We may also receive information about you from third-party sources, such as Shopify. "
            )
          ])
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v("How We Use Your Information")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " We may use your personal information for the following purposes: "
          )
        ]),
        _c("ul", { staticClass: "list-disc pl-4 mb-4" }, [
          _c("li", [_vm._v("To provide and maintain our App.")]),
          _c("li", [
            _vm._v("To personalize your experience and improve the App.")
          ]),
          _c("li", [
            _vm._v(
              " To communicate with you about the App and any updates or changes. "
            )
          ]),
          _c("li", [
            _vm._v("To respond to your inquiries, comments, and feedback.")
          ]),
          _c("li", [
            _vm._v("To detect, prevent, and address technical issues.")
          ]),
          _c("li", [
            _vm._v("To comply with any applicable laws and regulations.")
          ])
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v(" How We Disclose Your Information ")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " We may disclose your personal information to the following types of third parties: "
          )
        ]),
        _c("ul", { staticClass: "list-disc pl-4 mb-4" }, [
          _c("li", [
            _vm._v(
              " Shopify and its service providers: We may share your personal information with Shopify and its service providers for the purpose of providing and maintaining the App. "
            )
          ]),
          _c("li", [
            _vm._v(
              " Other third parties: We may share your personal information with other third parties if we have your consent to do so, or if we are required to do so by law. "
            )
          ])
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v("Your Choices")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " You may choose to restrict the collection or use of your personal information by not installing our App. You may also request that we delete your personal information by contacting us at [insert email address]. Please note that we may not be able to provide the App to you if you request that we delete your personal information. "
          )
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v("Security")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " We take reasonable measures to protect your personal information from unauthorized access, use, and disclosure. However, no security measure is perfect, and we cannot guarantee the security of your personal information. "
          )
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v(" For processing WhatsApp messages ")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " Name, Email Address, Address and order details to send Abandoned cart, order notifications or shipping notification messages from each of your orders "
          )
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v(
            " Our service vendors where we share data to help us serve you "
          )
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(" Google Analytics – to track analytics of the account "),
          _c("br"),
          _vm._v(" Firebase – To store real-time data sets "),
          _c("br"),
          _vm._v(" Mailchimp – To send update and marketing emails "),
          _c("br"),
          _vm._v(" Amazon – Cloud hosting provider "),
          _c("br"),
          _vm._v(" Mongo DB Atlas – Database hosting provider ")
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v("Changes to This Policy")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " We may update this Policy from time to time. If we make material changes to this Policy, we will notify you by email or by posting a notice on our website. Your continued use of the App after any changes to this Policy constitutes your acceptance of the changes. "
          )
        ]),
        _c("h3", { staticClass: "text-md font-semibold mb-2" }, [
          _vm._v("Contact Us")
        ]),
        _c("p", { staticClass: "mb-4" }, [
          _vm._v(
            " If you have any questions or concerns about this Policy, please contact us at help@carthike.com. "
          )
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }